import { hasValueAndNotEmpty } from "@itk/typescript-utils";

export const getFileNameWithoutExtension = (fileName: string | undefined) => {
  if (hasValueAndNotEmpty(fileName)) {
    return fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
  } else {
    return "";
  }
};
